import { Box, BoxProps } from 'src/components/Box';
import { useNativeBridge } from 'src/contexts/NativeBridgeContext';

export interface SafeAreaProps {
  top?: boolean;
  bottom?: boolean;
  mode?: 'margin' | 'padding' | 'space';
  sx?: BoxProps['sx'];
  children?: React.ReactNode;
  // Forwarded to the root element, e.g. markers that other code looks up.
  [dataAttribute: `data-${string}`]: string | undefined;
}

export const SafeArea: React.FC<SafeAreaProps> = ({
  top,
  bottom,
  mode = 'padding',
  children,
  sx,
  ...dataAttributes
}) => {
  const { inset } = useNativeBridge();

  const cssVarTop = inset.top
    ? `${inset.top}px`
    : `env(safe-area-inset-top, ${inset.top + 'px'})`;
  const cssVarBottom = inset.bottom
    ? `${inset.bottom}px`
    : `env(safe-area-inset-bottom, ${inset.bottom + 'px'})`;

  const styles = [
    mode === 'padding' &&
      top && {
        paddingTop: cssVarTop,
      },
    mode === 'padding' &&
      bottom && {
        paddingBottom: cssVarBottom,
      },
    mode === 'margin' &&
      top && {
        marginTop: cssVarTop,
      },
    mode === 'margin' &&
      bottom && {
        marginBottom: cssVarBottom,
      },
    mode === 'space' &&
      top && {
        height: cssVarTop,
      },
    mode === 'space' &&
      bottom && {
        height: cssVarBottom,
      },
  ];

  return (
    <Box
      {...dataAttributes}
      sx={[...styles, ...(Array.isArray(sx) ? sx : [sx])]}
    >
      {children}
    </Box>
  );
};
